/* eslint-disable no-unused-vars */
import { NavState } from './nav/types';
import { ViewByMatchState } from './view-by-match/types';
import { VideoListState } from './video-list/types';

/**
 * @typedef {object} VideoHubState
 * @property {NavState} nav
 * @property {ViewByMatchState} viewByMatch
 * @property {VideoListState} videoList
 */
